'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _propTypes2 = require('@marmalade/prop-types');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _contact = require('@marmalade/contact');
var _detailsPanel = require('./details-panel');
var _detailsPanel2 = _interopRequireDefault(_detailsPanel);
var _regLookup = require('./reg-lookup');
var _regLookup2 = _interopRequireDefault(_regLookup);
var _manualLookup = require('./manual-lookup');
var _manualLookup2 = _interopRequireDefault(_manualLookup);
var _cdlOptions = require('./cdl-options');
var _cdlOptions2 = _interopRequireDefault(_cdlOptions);
var _controlFields = require('../../hocs/control-fields');
var _controlFields2 = _interopRequireDefault(_controlFields);
var _vehicleLookup = require('../../selectors/vehicle-lookup');
var _vehicleLookup2 = require('../../actions/vehicle-lookup');
var _updateFields = require('../../actions/update-fields');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var VehicleLookup = function (_Component) {
  _inherits(VehicleLookup, _Component);
  function VehicleLookup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, VehicleLookup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VehicleLookup.__proto__ || Object.getPrototypeOf(VehicleLookup)).call.apply(_ref, [this].concat(args))), _this), _this.vehicleDescriber = _this.props.product === 'ldi' ? 'The' : 'Your', _this.vehicleDescriberLower = _this.vehicleDescriber.toLowerCase(), _this.labels = Object.assign({
      regLookup: 'Registration',
      regPlaceholder: _this.vehicleDescriber + ' reg',
      details: _this.vehicleDescriber + ' vehicle',
      chooseManual: 'Don\'t know ' + _this.vehicleDescriberLower + ' reg?',
      resetDetails: 'Not ' + _this.vehicleDescriberLower + '  vehicle?',
      resetManual: 'Know ' + _this.vehicleDescriberLower + '  reg?'
    }, _this.props.customLabels), _this.resetLookup = function () {
      _this.props.resetLookup(_this.props.formId);
      _this.props.resetFields(_this.props.formId, ['regNo', 'abiCode', 'value', 'vehicleOptions', 'manufacturerOptions', 'modelOptions', 'transOptions', 'getModelOptions', 'fuelOptions', 'engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions']);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(VehicleLookup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // stop address from slipping out of view when state changes
      if (this.props.mobile && this.props.view !== prevProps.view) {
        document.getElementById(this.props.name).scrollIntoView();
        // the scrollOffset is for working with fixed headers (and the like...)
        window.scroll(0, window.scrollY - this.props.scrollOffset);
      }
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      var error = typeof this.props.errors.abiCode !== 'undefined' ? !!this.props.errors.abiCode.length : false;
      return this.props.requestError || this.props.manualError || error;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var props = {
        error: this.hasError(),
        resetLookup: this.resetLookup
      };
      switch (this.props.view) {
        case 'cdlOptions':
          return _react2.default.createElement(_cdlOptions2.default, props);
        case 'manualLookup':
          return _react2.default.createElement(_manualLookup2.default, Object.assign({
            reset: this.labels.resetManual
          }, props));
        case 'details':
          return _react2.default.createElement(_detailsPanel2.default, {
            label: this.labels.details,
            reset: this.labels.resetDetails,
            resetLookup: this.resetLookup
          });
        case 'regLookup':
        default:
          return _react2.default.createElement(_regLookup2.default, {
            error: this.hasError(),
            label: this.labels.regLookup,
            placeholder: this.labels.regPlaceholder,
            chooseManual: this.labels.chooseManual,
            disableManualLookup: this.props.disableManualLookup
          });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        id: this.props.name
      }, this.hasError() && _react2.default.createElement(_message2.default, {
        type: 'error',
        css: {
          paddingBottom: '1rem'
        }
      }, 'Sorry, we couldn\'t find your vehicle. Please try again or call ', _contact.constants.phone.products, ' for assistance.'), this.renderContent());
    }
  }]);
  return VehicleLookup;
}(_react.Component);
VehicleLookup.propTypes = {
  // props
  disableManualLookup: _propTypes.bool,
  name: _propTypes.string,
  scrollOffset: _propTypes.number,
  // controlFields
  formId: _propTypes.string.isRequired,
  product: _propTypes2.product.isRequired,
  errors: (0, _propTypes.objectOf)(_propTypes.string).isRequired,
  // stp
  view: (0, _propTypes.oneOf)(['regLookup', 'manualLookup', 'cdlOptions', 'details']).isRequired,
  requestError: _propTypes.bool.isRequired,
  manualError: _propTypes.bool.isRequired,
  mobile: _propTypes.bool.isRequired,
  // dtp
  resetLookup: _propTypes.func.isRequired,
  resetFields: _propTypes.func.isRequired,
  customLabels: (0, _propTypes.shape)({
    regLookup: _propTypes.string,
    regPlaceholder: _propTypes.string,
    details: _propTypes.string,
    chooseManual: _propTypes.string,
    resetDetails: _propTypes.string,
    resetManual: _propTypes.string
  })
};
VehicleLookup.defaultProps = {
  disableManualLookup: false,
  name: 'vehicleLookup',
  scrollOffset: 100,
  customLabels: undefined
};
exports.default = (0, _controlFields2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    view: (0, _vehicleLookup.vehicleLookupView)(state, ownProps.formId),
    requestError: (0, _vehicleLookup.cdlError)(state, ownProps.formId),
    manualError: (0, _vehicleLookup.manualLookupRequestError)(state, ownProps.formId),
    mobile: (0, _reduxWindow.getWidth)(state) < 768
  };
}, {
  resetLookup: _vehicleLookup2.resetVehicleLookup,
  resetFields: _updateFields.resetFields
})(VehicleLookup));